import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPackageIn: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="package-in,delivery"><path d="M20.25 10.25V3.75H3.75V20.25H12.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.75 3.75V9.25H15.25V3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M21.25 20.25V18C21.25 16.8954 20.3546 16 19.25 16H15M16.75 13.75L14.5 16L16.75 18.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconPackageIn;
